import * as Yup from 'yup';


export const validationSchemas = Yup.object({
      LinkedIn: Yup.string().url("Invalid URL format. Use format: https://www.example.com"),
      Website: Yup.string().url("Invalid URL format. Use format: https://www.example.com"),
    })
